import { memo, useCallback, useMemo } from 'react';
import MyProfileSection from './MyProfileSection/MyProfileSection';
import {
  getPersonalInfoInitialState,
  parseFieldData,
} from './MyProfileSection/MyProfileSection.utils';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  MyProfileField,
  selectAccount,
  updatePersonalDetails,
} from '../../state';
import { useMyProfileForm } from '../../hooks/useMyProfileForm';
import { AccountService } from '../../api';
import { BottomSheet } from '@bonanza-social/navigation';

function PersonalInfo() {
  const account = useSelector(selectAccount);
  const dispatch = useDispatch();
  const initialFieldData = useMemo(
    () => getPersonalInfoInitialState(account),
    [account],
  );

  const handleServiceCall = useCallback(
    async (fieldData: MyProfileField[]) => {
      const fieldMap = parseFieldData(fieldData);

      try {
        const personalDetailsData = {
          personalDetails: {
            countryOfResidence: fieldMap.myProfileCountryOfResidence,
            citizenship: fieldMap.myProfileCitizenship,
            alias: fieldMap.myProfileAlias,
          },
        };
        await AccountService.updatePersonalDetails({
          data: personalDetailsData,
        });
        dispatch(updatePersonalDetails(personalDetailsData));
        BottomSheet.open({
          namespace: 'common',
          type: 'Info',
          titleNS: 'account',
          titleKey: 'myProfileSuccessTitle',
          data: {
            textNS: 'account',
            textKey: 'myProfileSucccessMessage',
          },
        });
      } catch {
        BottomSheet.open({
          namespace: 'common',
          type: 'Info',
          titleNS: 'account',
          titleKey: 'myProfileErrorTitle',
          data: {
            textNS: 'account',
            textKey: 'myProfileErrorMessage',
          },
        });
      }
    },
    [dispatch],
  );

  const {
    fieldData,
    onChange,
    onSubmitForm,
    isSubmiting,
    isEditing,
    toggleEdit,
  } = useMyProfileForm(initialFieldData, handleServiceCall);

  return (
    <MyProfileSection
      titleLocKey="myProfilePersonalInformationTitle"
      fieldData={fieldData}
      onChange={onChange}
      onSubmitForm={onSubmitForm}
      isSubmiting={isSubmiting}
      isEditing={isEditing}
      toggleEdit={toggleEdit}
      disableEditing
    />
  );
}

export default memo(PersonalInfo);
